<template>
  <div class="qyxxbgDiaLogBody">
    <div
      style="
        position: absolute;
        right: 30px;
        top: 30px;
        font-size: 30px;
        color: #606266;
        cursor: pointer;
      "
      @click="back"
    >
      <i class="el-icon-circle-close" />
    </div>
    <div class="_title">
      <p class="_title_info">基本信息</p>
    </div>
    <div class="_yyzzPic">
      <el-image
        :src="yyzzImg.img"
        draggable="false"
        :preview-src-list="srcList"
        style="width: 196px; height: 227px"
        alt=""
      />
    </div>
    <p style="text-align: center">{{ dwxzWorld }}</p>
    <div class="_jbxxInfo">
      <div class="_jbxxTitle">单位基本信息</div>
      <div class="_jbxxBd">
        <el-form
          disabled
          :model="dwBgjlDtoFu"
          label-position="right"
          class="_jbxxForm"
          label-width="140px"
        >
          <el-form-item v-if="labelFlag.dwmc" :label="dwmcName">
            <el-input
              v-model="dwBgjlDtoFu.dwmc.afterValue"
              placeholder="请输入单位名称"
            />
            <el-popover
              v-show="dwBgjlDtoFu.dwmc.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + dwBgjlDtoFu.dwmc.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item label="单位性质:">
            <el-select
              v-model="dwBgjlDtoFu.dwxz.afterValue"
              style="width: 100%"
              placeholder="请选择单位性质 "
            >
              <el-option
                v-for="(item, i) in dwxzList"
                :key="i"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-popover
              v-show="dwBgjlDtoFu.dwxz.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + dwxzName"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item v-if="labelFlag.shtyxydm" :label="shtyxydmName">
            <el-input
              v-model="dwBgjlDtoFu.shtyxydm.afterValue"
              placeholder="请输入统一社会信用代码"
            />
            <el-popover
              v-show="dwBgjlDtoFu.shtyxydm.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + dwBgjlDtoFu.shtyxydm.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item v-if="labelFlag.dwlx" :label="dwlxName">
            <el-select
              v-model="dwBgjlDtoFu.dwlx.afterValue"
              style="width: 100%"
              placeholder="请选择单位类型"
            >
              <el-option
                v-for="(item, i) in dwlxList"
                :key="i"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-popover
              v-show="dwBgjlDtoFu.dwlx.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + dwlxName"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item v-if="labelFlag.YyqxDate" :label="YyqxDateName">
            <el-date-picker
              v-model="dwBgjlDtoFu.YyqxDate"
              style="width: 100%"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
            <el-popover
              v-show="
                dwBgjlDtoFu.yyqxJs.isChange || dwBgjlDtoFu.yyqxKs.isChange
              "
              placement="top-start"
              width="200"
              trigger="hover"
              :content="
                '修改前内容:' +
                  dwBgjlDtoFu.yyqxKs.beforeValue +
                  '~' +
                  dwBgjlDtoFu.yyqxJs.beforeValue
              "
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item v-if="labelFlag.clrq" :label="clrqName">
            <el-date-picker
              v-model="dwBgjlDtoFu.clrq.afterValue"
              style="width: 100%"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="date"
              placeholder="请选择成立日期"
            />
            <el-popover
              v-show="dwBgjlDtoFu.clrq.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + dwBgjlDtoFu.clrq.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item
            v-if="labelFlag.zczb"
            class="zczbItem"
            :label="zczbName"
            width="120px"
          >
            <el-input
              v-model="dwBgjlDtoFu.zczb.afterValue"
              placeholder="请输入注册资本"
            >
              <el-select
                slot="append"
                v-model="dwBgjlDtoFu.zczbDw.afterValue"
                style="width: 100px"
                placeholder="请选择货币"
              >
                <el-option
                  v-for="(item, i) in djdwList"
                  :key="i"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-input>
            <el-popover
              v-show="dwBgjlDtoFu.zczb.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + dwBgjlDtoFu.zczb.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item v-if="labelFlag.frmc" :label="frmcName">
            <el-input
              v-model="dwBgjlDtoFu.frmc.afterValue"
              placeholder="请输入法人/经营者"
            />
            <el-popover
              v-show="dwBgjlDtoFu.frmc.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + dwBgjlDtoFu.frmc.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item label="发证机关:">
            <el-input
              v-model="dwBgjlDtoFu.fzjg.afterValue"
              placeholder="请输入发证机关"
            />
            <el-popover
              v-show="dwBgjlDtoFu.fzjg.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + dwBgjlDtoFu.fzjg.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item v-if="labelFlag.zhxs" label="组合形式">
            <el-input
              v-model="dwBgjlDtoFu.zhxs.afterValue"
              placeholder="请输入组合形式"
            />
            <el-popover
              v-show="dwBgjlDtoFu.zhxs.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + dwBgjlDtoFu.zhxs.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="_qtxxInfo">
      <div class="_qtxxTitle">单位其他信息</div>
      <div class="_qtxxBd">
        <el-form
          disabled
          label-position="right"
          class="_qtxxForm"
          label-width="140px"
          :model="dwBgjlDtoFu"
        >
          <el-form-item v-if="labelFlag.dwzj" :label="dwzjName">
            <el-input
              v-model="dwBgjlDtoFu.dwzj.afterValue"
              placeholder="请输入单位座机 例:010-86551122"
            />
            <el-popover
              v-show="dwBgjlDtoFu.dwzj.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + dwBgjlDtoFu.dwzj.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item v-if="labelFlag.cyrysl" :label="cyryslName">
            <el-input
              v-model="dwBgjlDtoFu.cyrysl.afterValue"
              placeholder="请输入从业人员数量"
            />
            <el-popover
              v-show="dwBgjlDtoFu.cyrysl.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + dwBgjlDtoFu.cyrysl.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item
            v-if="labelFlag.gsgajg"
            style="width: 100%"
            :label="gsgajgName"
          >
            <el-input
              v-model="dwBgjlDtoFu.provinceLabel.afterValue+' / '+dwBgjlDtoFu.cityLabel.afterValue+' / '+dwBgjlDtoFu.countyLabel.afterValue"
              placeholder="请输入行政区划"
            />
            <el-popover
              v-show="dwBgjlDtoFu.countyLabel.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + dwBgjlDtoFu.provinceLabel.beforeValue+' / '+dwBgjlDtoFu.cityLabel.beforeValue+' / '+dwBgjlDtoFu.countyLabel.beforeValue"
            >
            </el-popover>
<!--            <el-cascader
              v-model="gsgajg"
              style="width: 100%"
              placeholder="请选择归属行政区划"
              :props="props"
            />-->
          </el-form-item>
          <el-form-item
            v-if="labelFlag.sjjyd"
            style="width: 100%"
            :label="sjjydName"
          >
            <el-input
              v-model="dwBgjlDtoFu.sjjyd.afterValue"
              placeholder="请输入实际经营地"
            />
            <el-popover
              v-show="dwBgjlDtoFu.sjjyd.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + dwBgjlDtoFu.sjjyd.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item
            v-if="labelFlag.dwzs"
            style="width: 100%"
            :label="dwzsName"
          >
            <el-input
              v-model="dwBgjlDtoFu.dwzs.afterValue"
              placeholder="请输入单位住所"
            />
            <el-popover
              v-show="dwBgjlDtoFu.dwzs.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + dwBgjlDtoFu.dwzs.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
          <el-form-item
            v-if="labelFlag.zcdqh"
            style="width: 100%"
            label="注册地区划:"
          >
            <el-input
              v-model="dwBgjlDtoFu.sjProvinceLabel.afterValue+' / '+dwBgjlDtoFu.sjCityLabel.afterValue+' / '+dwBgjlDtoFu.sjCountyLabel.afterValue"
              placeholder="请输入注册地区划"
            />
            <el-popover
              v-show="dwBgjlDtoFu.sjCountyLabel.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + dwBgjlDtoFu.sjProvinceLabel.beforeValue+' / '+dwBgjlDtoFu.sjCityLabel.beforeValue+' / '+dwBgjlDtoFu.sjCountyLabel.beforeValue"
            >
            </el-popover>
            <!--            <el-cascader
                          v-model="gsgajg"
                          style="width: 100%"
                          placeholder="请选择归属行政区划"
                          :props="props"
                        />-->
          </el-form-item>
          <el-form-item
            v-if="labelFlag.jyfw"
            style="width: 100%"
            :label="jyfwName"
          >
            <el-input
              v-model="dwBgjlDtoFu.jyfw.afterValue"
              type="textarea"
              :rows="3"
              resize="none"
              placeholder="请输入经营范围"
            />
            <el-popover
              v-show="dwBgjlDtoFu.jyfw.isChange"
              placement="top-start"
              width="200"
              trigger="hover"
              :content="'修改前内容:' + dwBgjlDtoFu.jyfw.beforeValue"
            >
              <img slot="reference" src="@/assets/img/tishiNew.png" alt="">
            </el-popover>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
// 获取接口地址
import {
  url1,
  getkv,
  returnSaveFile,
  returnShowPic
} from '@/assets/js/common.js'
import { getXzqTree, getXzqTreeS } from '@/assets/js/step2.js'
export default {
  props: {
    dwBgjlDto: {
      type: Object,
      default: () => {
        return {
          zczbDw: {}
        }
      }
    }
  },
  data() {
    return {
      props: {
        lazy: true, // 开启懒加载
        lazyLoad(node, resolve) {
          const { level } = node
          setTimeout(() => {
            if (level == 0) {
              getXzqTree().then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            } else {
              getXzqTreeS(node.value).then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            }
          }, 500)
        }
      },
      dwxzName: '',
      srcList: [], // 大图预览
      dwxzList: [], // 性质下拉
      dwlxList: [], // 单位类型下拉
      djdwList: [], // 货币下拉
      yyzzImg: {
        // 营业执照数据
        name: '营业执照',
        img: require('@/assets/img/yyzz.png'),
        closeBox: false,
        loading: false
      },
      name: '', // 确认内层弹窗的内容
      imgListArray: [], // 许可证图片
      innerVisible: false, // 内层dialog是否显示
      lxrxmList: [], // 联系人姓名
      title: '', // 上传弹窗的标题  确认内层弹窗的内容
      // 控制form表单item显示
      labelFlag: {
        dwmc: true, // 单位名称
        shtyxydm: true, // 社会统一信用代码
        dwxz: '1', // 单位性质
        dwlx: true, // 单位类型
        dwzs: true, // 单位住所
        frmc: true, // 法人/经营者名称
        zczb: true, // 注册资本
        clrq: true, // 成立日期
        jyfw: true, // 经营范围
        dwzj: true, // 单位座机
        sjjyd: true, // 实际经营地
        cyrysl: true, // 从业人员数量
        YyqxDate: true, // 营业执照路径
        gsgajg: true,
        zcdqh: true,
      },
      // 动态form标签名
      dwxzWorld: '营业执照',
      dwmcName: '单位名称:',
      shtyxydmName: '统一社会信用代码:',
      dwlxName: '单位类型:',
      dwzsName: '单位住所:',
      frmcName: '法人/经营者:',
      zczbName: '注册资本:',
      clrqName: '成立日期:',
      jyfwName: '经营范围:',
      dwzjName: '单位座机:',
      sjjydName: '实际经营地:',
      cyryslName: '从业人员数量:',
      YyqxDateName: '营业期限:',
      gsgajgName: '行政区划:'
    }
  },
  computed: {
    dwBgjlDtoFu: {
      get() {
        // 解决js无法识别三级对象问题
        return Object.assign(
          { zczbDw: {}, fzjg: {}, zhxs: {}},
          this.dwBgjlDto
        )
      },
      set(val) {
        this.$emit('getdwBgjlDto', val)
      }
    }
  },
  watch: {
    dwBgjlDtoFu(newValue, oldValue) {
      this.panduan(newValue.dwxz.afterValue)
      /* 时间选择器赋值回显 */
      if (
        newValue.yyqxKs.afterValue != '' &&
        newValue.yyqxKs.afterValue != null
      ) {
        this.dwBgjlDtoFu.YyqxDate = [
          newValue.yyqxKs.afterValue,
          newValue.yyqxJs.afterValue
        ]
      }

      /* 营业执照回显 */
      if (
        newValue.yyzzUrl.afterValue != '' &&
        newValue.yyzzUrl.afterValue != null
      ) {
        this.yyzzImg.img = this.returnShowPic + newValue.yyzzUrl.afterValue
        this.srcList.push(this.yyzzImg.img)
      }
      this.dwxzList.forEach((element) => {
        if (newValue.dwxz.beforeValue === element.value) {
          this.dwxzName = element.label
        }
      })
      this.dwlxList.forEach((element) => {
        if (newValue.dwlx.beforeValue === element.value) {
          this.dwlxName = element.label
        }
      })
    }
  },
  created() {
    // 获取图片路径前缀
    this.URL1 = url1()
    this.returnSaveFile = returnSaveFile()
    this.returnShowPic = returnShowPic()
  },
  mounted() {
    /* 字典项 */
    getkv('yzd_dwxz').then((e) => {
      this.dwxzList = e.data.data
    })
    getkv('yzd_dwlx').then((e) => {
      this.dwlxList = e.data.data
    })
    getkv('yzd_xkzdjdw').then((e) => {
      this.djdwList = e.data.data
    })
  },
  methods: {
    // 返回父页面
    back() {
      this.$bus.emit('exit')
    },
    // 判断显示字段
    panduan(value) {
      switch (value) {
        case '1':
          this.dwxzWorld = '营业执照'
          this.labelFlag = {
            dwmc: true, // 单位名称
            shtyxydm: true, // 社会统一信用代码
            dwlx: true, // 单位类型
            dwzs: true, // 单位住所
            frmc: true, // 法人/经营者名称
            zczb: true, // 注册资本
            clrq: true, // 成立日期
            jyfw: true, // 经营范围
            dwzj: true, // 单位座机
            sjjyd: true, // 实际经营地
            cyrysl: true, // 从业人员数量
            YyqxDate: true, // 营业
            gsgajg: true,
            zcdqh: true,
          }
          this.dwmcName = '单位名称:'
          this.shtyxydmName = '统一社会信用代码:'
          this.dwlxName = '单位类型:'
          this.dwzsName = '单位住所:' //
          this.frmcName = '法人/经营者:' //
          this.zczbName = '注册资本:' //
          this.clrqName = '成立日期:' //
          this.jyfwName = '经营范围:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.sjjydName = '实际经营地:' //
          this.cyryslName = '从业人员数量:' //
          this.YyqxDateName = '营业期限:' //
          this.gsgajgName = '行政区划:'
          break
        case '7':
          this.dwxzWorld = '营业执照'
          this.labelFlag = {
            dwmc: true, // 单位名称
            shtyxydm: true, // 社会统一信用代码
            dwlx: true, // 单位类型
            dwzs: true, // 单位住所
            frmc: true, // 法人/经营者名称
            zczb: true, // 注册资本
            clrq: true, // 成立日期
            jyfw: true, // 经营范围
            dwzj: true, // 单位座机
            sjjyd: true, // 实际经营地
            cyrysl: true, // 从业人员数量
            YyqxDate: true, // 营业执照路径
            gsgajg: true,
            zcdqh: true,
          }
          this.dwmcName = '单位名称:'
          this.shtyxydmName = '统一社会信用代码:'
          this.dwlxName = '单位类型:'
          this.dwzsName = '单位住所:' //
          this.frmcName = '法人/经营者:' //
          this.zczbName = '注册资本:' //
          this.clrqName = '成立日期:' //
          this.jyfwName = '经营范围:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.sjjydName = '实际经营地:' //
          this.cyryslName = '从业人员数量:' //
          this.YyqxDateName = '营业期限:' //
          this.gsgajgName = '行政区划:'
          break
        case '3':
          this.dwxzWorld = '社会团体法人/经营者登记证书'
          this.labelFlag = {
            dwmc: true, // 单位名称
            jyfw: true, // 经营范围
            dwzs: true, // 单位住所
            shtyxydm: true, // 社会统一信用代码
            sjjyd: true, // 实际经营地
            zczb: true, // 注册资本
            gsgajg: true,
            zcdqh: true,
            YyqxDate: true, // 营业执照路径
            clrq: true // 成立日期
          }
          this.dwmcName = '名称:'
          this.jyfwName = '业务范围:' //
          this.dwzsName = '住所:' //
          this.shtyxydmName = '统一社会信用代码:'
          this.sjjydName = '活动地域:' //
          this.zczbName = '注册资本:' //
          this.gsgajgName = '业务主管单位:'
          this.YyqxDateName = '有效期:' //
          this.clrqName = '发证日期:'
          break
        case '2':
          this.dwxzWorld = '事业单位法人/经营者证书'
          this.labelFlag = {
            dwmc: true, // 单位名称
            jyfw: true, // 经营范围
            dwzs: true, // 单位住所
            shtyxydm: true, // 社会统一信用代码
            zczb: true, // 注册资本
            gsgajg: true,
            zcdqh: true,
            YyqxDate: true,
            clrq: true // 成立日期
          }
          this.dwmcName = '名称:'
          this.jyfwName = '宗旨和业务范围:' //
          this.dwzsName = '住所:' //
          this.shtyxydmName = '统一社会信用代码:'
          this.zczbName = '开办资金:' //
          this.gsgajgName = '登记管理机关:'
          this.YyqxDateName = '有效期:' //
          this.clrqName = '发证日期:' //
          break
        case '5':
          this.dwxzWorld = '行政执法主体资格证'
          this.labelFlag = {
            dwmc: true, // 单位名称
            sjjyd: true, // 实际经营地
            YyqxDate: true, // 营业执照路径
            shtyxydm: true, // 社会统一信用代码
            gsgajg: true,
            zcdqh: true
          }
          this.dwmcName = '单位名称:'
          this.sjjydName = '办公地址:' //
          this.YyqxDateName = '有效期:' //
          this.shtyxydmName = '证件编号:'
          this.gsgajgName = '行政区划:'
          break
        case '8':
          this.labelFlag = {
            dwmc: true, // 单位名称
            shtyxydm: true, // 社会统一信用代码
            dwlx: false, // 单位类型
            dwzs: true, // 单位住所
            frmc: true, // 法人/经营者名称
            zczb: true, // 注册资本
            clrq: true, // 成立日期
            jyfw: true, // 经营范围
            dwzj: true, // 单位座机
            sjjyd: true, // 实际经营地
            cyrysl: true, // 从业人员数量
            YyqxDate: true, // 营业
            gsgajg: true,
            zcdqh: true,
            zhxs: true
          }
          this.dwmcName = '字号名称:'
          this.shtyxydmName = '注册号:'
          this.dwlxName = '单位类型:'
          this.dwzsName = '单位住所:' //
          this.frmcName = '经营者:' //
          this.zczbName = '注册资本:' //
          this.clrqName = '成立日期:' //
          this.jyfwName = '经营范围:' //
          this.dwzjName = '单位座机:' // 单位座机
          this.sjjydName = '实际经营地:' //
          this.cyryslName = '从业人员数量:' //
          this.YyqxDateName = '有效期限:' //
          this.gsgajgName = '行政区划:'
          break
        default:
          this.dwxzWorld = '营业执照'
          this.labelFlag = {
            shtyxydm: true, // 社会统一信用代码
            dwmc: true, // 单位名称
            dwzs: true, // 单位住所
            jyfw: true, // 经营范围
            YyqxDate: true, // 营业执照路径
            clrq: true, // 成立日期
            gsgajg: true,
            zcdqh: true,
          }
          this.shtyxydmName = '编号:'
          this.dwmcName = '单位名称:'
          this.dwzsName = '单位地址:' //
          this.jyfwName = '许可范围:' //
          this.YyqxDateName = '有效期:' //
          this.clrqName = '发证日期:' //
          this.gsgajgName = '行政区划:'
          break
      }
    }
  }
}
</script>
<style lang="less" scoped>
.qyxxbgDiaLogBody {
  width: 90%;
  max-width: 1200px;
  margin: 20px auto 0px auto;
  display: flex;
  background-color: #fff;
  flex-direction: column;
  align-items: center;
  position: relative;
  ._title {
    width: 80px;
    margin-top: 50px;
    ._title_info {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
    }
  }
  /deep/.el-upload-list {
    margin: 0;
    padding: 0;
    list-style: none;
    position: absolute;
    right: 0;
    top: -10px;
  }
  /deep/.deleteUpload {
    width: 25px;
    height: 25px;
    position: absolute;
    right: 0;
    top: 15px;
    cursor: pointer;
    color: white;
  }
  ._yyzzPic {
    margin-top: 40px;
    position: relative;
    /deep/.el-upload-list {
      margin: 0;
      padding: 0;
      list-style: none;
      position: absolute;
      right: 0;
      top: -10px;
    }
    /deep/.deleteUpload {
      width: 25px;
      height: 25px;
      position: absolute;
      right: 0;
      top: 15px;
      cursor: pointer;
      color: white;
    }
  }
  ._jbxxInfo {
    margin-top: 70px;
    width: 85%;
    ._jbxxTitle {
      width: 96px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
    }
    ._jbxxBd {
      margin: 30px 0px;
      ._jbxxForm {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .el-form-item {
          margin-right: 0;
          width: 45%;
          /deep/.el-form-item__content {
            display: flex !important;
          }
        }
      }
    }
  }
  ._qtxxInfo {
    width: 85%;
    ._qtxxTitle {
      width: 96px;
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 22px;
    }
    ._qtxxBd {
      margin: 30px 0px;
      ._qtxxForm {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .el-form-item {
          margin-right: 0;
          width: 45%;
          /deep/.el-form-item__content {
            display: flex !important;
          }
        }
      }
    }
  }
}
</style>
